import React from 'react';
import { ArrowSimpleDownIcon } from 'components/Icons/ArrowSimpleDown';
import { ArrowSimpleUpIcon } from 'components/Icons/ArrowSimpleUp';
import cn from './styles.module.scss';

type ExpandIconProps<RecordType> = {
  expanded: boolean,
  onExpand: (record: RecordType, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  record: RecordType,
};

export function ExpandIcon<RecordType>({ expanded, onExpand, record }: ExpandIconProps<RecordType>) {
  return (expanded ? (
    <ArrowSimpleUpIcon
      className={cn.icon}
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => onExpand(record, e)}
    />
  ) : (
    <ArrowSimpleDownIcon
      className={cn.icon}
      onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => onExpand(record, event)}
    />
  ));
}
